/**
 * Copyright (c) 2017-present, Tomaruba, Inc.
 * All rights reserved.
 */
import { Component } from 'react'
import { Container } from 'flux/utils'
import { withRouter } from 'react-router'
import ListView from '../../view/pages/accommodation_invoice/ListView'
import NProgress from 'nprogress'
import AccommodationInvoiceSearchStore from '../../store/accommodation_invoice/AccommodationInvoiceSearchStore'
import SessionAction from '../../action/session'
import AccommodationInvoiceAction from '../../action/accommodation_invoice'
import HotelOptionsStore from '../../store/options/HotelOptionsStore'
import AccommodationInvoicesStore from '../../store/accommodation_invoice/AccommodationInvoicesStore'
import AccommodationInvoiceStore from '../../store/accommodation_invoice/AccommodationInvoiceStore'
import AccommodationInvoiceDetailsStore from '../../store/accommodation_invoice/AccommodationInvoiceDetailsStore'
import AccommodationInvoiceRefundStore from '../../store/accommodation_invoice/AccommodationInvoiceRefundStore'
import AccommodationInvoicePaginationStore from '../../store/accommodation_invoice/AccommodationInvoicePaginationStore'
import ReservationStore from '../../store/accommodation_invoice/ReservationStore'

class ListContainer extends Component {
  static getStores() {
    return [
      HotelOptionsStore,
      AccommodationInvoiceSearchStore,
      AccommodationInvoicesStore,
      AccommodationInvoiceStore,
      AccommodationInvoiceDetailsStore,
      AccommodationInvoiceRefundStore,
      ReservationStore,
      AccommodationInvoicePaginationStore
    ]
  }

  static calculateState(prevState, props) {
    return {
      option_hotels: HotelOptionsStore.getState(),
      search: AccommodationInvoiceSearchStore.getState(),
      invoices: AccommodationInvoicesStore.getState(),
      invoice: AccommodationInvoiceStore.getState(),
      invoice_details: AccommodationInvoiceDetailsStore.getState(),
      refund: AccommodationInvoiceRefundStore.getState(),
      reservation: ReservationStore.getState(),
      pagination: AccommodationInvoicePaginationStore.getState(),
      ...props
    }
  }

  async componentDidMount() {
    NProgress.start()

    const id = this.state.match.params.id
    if (id) {
      await AccommodationInvoiceAction.fetchOne(id)
      NProgress.done()
      return
    }

    await SessionAction.fetchUserHotels()
    await AccommodationInvoiceAction.onSearch(this.state.search, this.state.pagination)

    NProgress.done()
  }

  render() {
    return ListView(this.state)
  }
}

export default withRouter(Container.create(ListContainer, { withProps: true }))
